const navigationEs = {
  menu: {
    tiendas: 'Tiendas',
    clientes: 'Clientes',
    packaging: 'Packaging',
    warehouse_material: 'Material almacén',
    puestos_trabajo: 'Puestos de trabajo',
    productos: 'Productos',
    productos_main: 'Productos',
    productos_packs: 'Packs',
    crm: 'CRM',
    crm_management_hours: 'Registro de horas CRM',
    reportes: 'Reportes',
    client_activity: 'Actividad de clientes',
    rentabilidad_section: 'Rentabilidad',
    profitability_overview: 'Resumen',
    profitability_ad_spend: 'Gasto publicitario',
    profitability_product_costs: 'Costes de producto',
    profitability_shipping_costs: 'Costes de envío',
    productos_sin_stock: 'Productos sin stock',
    pedidos: 'Pedidos',
    pedidos_main: 'Pedidos',
    pedidos_preparar: 'Pedidos por preparar',
    pedidos_retenidos: 'Pedidos retenidos',
    pedidos_enviados: 'Pedidos enviados',
    shipment_status_transitions: 'Transiciones logísticas',
    billeteras: 'Billetera',
    retiros: 'Retiros',
    payment_files: 'Ficheros de pago',
    billeteras_main: 'Billeteras',
    cuentas_bancarias: 'Cuentas bancarias',
    recargas: 'Recargas',
    wallets_accounting_sync: 'Contabilidad Holded',
    ordenes_ubicacion: 'Órdenes de ubicación',
    preparar_pedidos: 'Preparación de pedidos',
    orders: 'Órdenes',
    preparaciones: 'Preparaciones',
    manifests: 'Manifiestos',
    packs: 'Packs',
    trabajos_extra: 'Trabajos extra',
    ubicaciones: 'Ubicaciones',
    carritos: 'Carritos',
    almacen: 'Almacén',
    almacen_configuracion: 'Configuración',
    almacen_grupo: 'Almacén',
    almacen_ordenes_ubicacion: 'Órdenes de ubicación',
    almacen_ubicaciones: 'Ubicaciones',
    almacen_ubicaciones_listado: 'Ubicaciones',
    almacen_ubicaciones_bloqueos: 'Bloqueos',
    almacen_traspasos: 'Traspasos',
    almacen_carritos: 'Carritos',
    almacen_reubicar: 'Reubicar',
    lotes: 'Lotes',
    almacen_informes: 'Informes',
    ready_to_prepare_by_hour: 'Pedidos por hora',
    warehouse_excel_reports: 'Exportación de informes',
    merchandise: 'Mercancías',
    receptions: 'Recepciones',
    entradas: 'Entradas',
    entradas_recepciones: 'Recepciones',
    entradas_recepciones_sin_identificar: 'Recepciones sin identificar',
    entradas_trabajos_extra: 'Trabajos extra',
    entradas_rehusados: 'Rehusados',
    entradas_identificar_software: 'Identificar software',
    cross_docking: 'Cross docking',
    cross_docking_operations: 'Operaciones',
    cross_docking_operations_new: 'Nueva operación',
    entradas_mercancias: 'Mercancías de clientes',
    movimientos: 'Movimientos',
    movimientos_stock: 'Stock',
    movimientos_ubicaciones: 'Ubicaciones',
    rehusados: 'Rehusados',
    dashboard: 'Dashboard',
    reusedDashboard: 'Dashboard',
    productivity: 'Productividad',
    devoluciones: 'Devoluciones',
    refund_receptions: 'Recepciones',
    identificar_software: 'Identificar software',
    incidencias: 'Incidencias',
    incidencias_main: 'Incidencias',
    mapeos: 'Mapeo Incidencias',
    configuracion: 'Configuración',
    backToApp: 'Volver a la app',
    configSectionAccount: 'Cuenta',
    configSectionTeam: 'Equipo',
    configSectionAdmin: 'Administración',
    empresa: 'Empresa',
    perfil: 'Perfil',
    suscripcion: 'Suscripción',
    logout: 'Cerrar sesión',
    workspace: 'Espacio de trabajo',
    printers: 'Impresoras',
    search_printer: 'Buscar impresora',
    general: 'General',
    wholesalePickups: 'Recogidas mayoristas',
    wholesalePreparations: 'Preparaciones mayoristas',
    wholesaleOrders: 'Pedidos mayoristas',
    wholesaleStagingZones: 'Zonas de espera',
    impresoras: 'Impresoras',
    preparationCalendar: 'Calendario de preparación',
    mensajerias: 'Mensajerías',
    rules: 'Reglas de envío',
    shippingRulePresets: 'Presets de Reglas de Envío',
    packagingRecipes: 'Recetas de packaging',
    coverageZones: 'Zonas de cobertura',
    shipmentStatusMapping: 'Estados Logísticos',
    courierErrorsMapping: 'Errores de courier',
    trackingMonitoring: 'Monitoreo de Tracking',
    trackingFiles: 'Ficheros de tracking',
    productCategories: 'Categorías de producto',
    warehouseMaterials: 'Materiales de almacén',
    integrations: 'Integraciones',
    webhooks: 'Webhooks',
    'mi-perfil': 'Mi perfil',
    notificaciones: 'Notificaciones',
    inicio: 'Inicio',
    theme: 'Tema',
    themes: {
      light: 'Claro',
      dark: 'Oscuro',
      system: 'Sistema',
    },
    language: 'Idioma',
    languages: {
      es: 'Español',
      en: 'English',
    },
    titles: {
      stock_movements: 'Movimientos de stock',
      location_movements: 'Movimientos de ubicación',
      integrated_messaging: 'Mensajerías Integradas',
      rules: 'Reglas de envío',
      logistics: 'Logística',
      profitability: 'Rentabilidad',
      logistic_pivot: 'Métricas de logística',
      inventory: 'Inventario',
      marketing: 'Marketing',
    },
    afiliados: 'Afiliados',
    afiliadosPartnersGrupo: 'Afiliados',
    afiliadosPartners: 'Afiliados (partners)',
    facturasAfiliadosPartners: 'Facturas de afiliados',
    roles: 'Roles',
    users: 'Usuarios',
    centro_ayuda: 'Centro de ayuda',
    contabilidad: 'Contabilidad',
    centros_coste: 'Centros de coste',
    facturacion: 'Facturación',
    facturacion_pedidos: 'Pedidos',
    facturacion_almacenamiento: 'Almacenamiento',
    facturacion_abonos_pedidos: 'Abonos de pedidos',
    facturacion_trabajos_extra: 'Trabajos extra elegibles',
    facturacion_wholesale: 'Preparación mayorista',
    facturacion_crm_management: 'CRM elegibles',
    facturacion_cuota_minima: 'Cuota mínima',
    facturacion_prefacturacion: 'Prefacturación',
    facturacion_facturas: 'Facturas',
    facturacion_tarifas: 'Tarifas',
    orders_without_weight: 'Pedidos sin peso',
    three_pl_excel_reports: 'Exportación de informes',
    legacy_dashboard: 'Clientes legacy activos',
    reportes_contabilidad: 'Reportes',
    contabilidad_carga_datos: 'Carga de datos',
    reembolsos_reporte: 'Liquidaciones reembolsos',
    global_search_placeholder: 'Búsqueda global',
    global_search: {
      title: 'Búsqueda global',
      mobile_placeholder: 'Busca en toda tu plataforma',
      modal_placeholder: 'Buscar por producto, pedido...',
      result: 'resultado',
      results: 'resultados',
      loading: 'Buscando...',
      no_results: 'No se encontraron resultados',
      no_results_title: 'Oops... No hemos encontrado nada.',
      no_results_description: 'Prueba de nuevo usando otros términos de búsqueda',
      no_product: 'Sin producto',
      no_status: 'Sin estado',
      navigate: 'Navegar',
      close: 'Cerrar',
      open: 'Abrir',
      go: 'Ir',
      category: {
        product: 'Producto',
        cart: 'En carrito',
        entry: 'Entradas',
        order: 'Pedido',
        merchandise: 'Mercancía',
        location: 'Ubicación',
        preparation: 'Preparación',
        returned_reception: 'Recepción devuelta',
      },
    },
    logistica: 'Logística',
    sla_couriers: 'SLA Couriers',
    sla_alertas: 'Alertas SLA',
    sla_reclamaciones: 'Reclamaciones',
    sla_reglas: 'Reglas SLA',
    sla_falsas_entregas: 'Falsas Entregas',
    sla_tipos_incumplimiento: 'Tipos de Incumplimiento',
    trackingFailures: 'Fallos de tracking API',
    cod_payments: 'Pagos COD',
    cod_payouts: 'Liquidaciones',
    cod_payout_items: 'Items de Liquidaciones',
    cod_reviews: 'Revisiones COD',
    cod_courier_files: 'Archivos Courier',
    cod_mismatches: 'Reporte de Reembolsos',
    packing: 'Packing',
    gestion_popups: 'Gestión de Popups',
    switchTeam: {
      success: {
        title: 'Empresa cambiada',
        description: 'Se ha cambiado de empresa exitosamente',
      },
      error: {
        title: 'Error al cambiar de empresa',
        unexpected: 'Error inesperado al cambiar de empresa. Inténtalo de nuevo.',
        profileLoad: 'No se pudo cargar el perfil de la nueva empresa.',
      },
    },
  },
  table: {
    activate: 'Activar',
    deactivate: 'Desactivar',
  },
};

export default navigationEs;
